<template>
        <el-container style="height: 100%;">
            <el-aside width="160px">
                <div class="seller-logo">建站后台管理</div>
                <el-menu default-active="active" class="el-menu-vertical-demo" @open="handleOpen"
                         @close="handleClose" router background-color="#303954"
                         text-color="#fff" active-text-color="#ffd04b">
                    <el-submenu :index="'menu-'+index" v-for="(menu,index) in menuList" :key="index" v-if="menu.children.length > 0">
                        <template slot="title">
                            <i :class="'iconfont '+menu.menu_icon"></i>
                            <span>{{menu.menu_name}}</span>
                        </template>
                        <el-menu-item :index="index+'-'+subIndex" v-for="(submenu,subIndex) in menu.children" :key="subIndex" :route="{path:submenu.menu_url}">{{submenu.menu_name}}</el-menu-item>
                    </el-submenu>
                  <el-menu-item :index="'menu-'+index" :route="{path:menu.menu_url}" v-else>
                    <i :class="'iconfont '+menu.menu_icon"></i>
                    <span slot="title">{{menu.menu_name}}</span>
                  </el-menu-item>
                </el-menu>
            </el-aside>
            <el-container>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>

</template>

<script>

    export default {
        name: 'index',
        data () {
            return {
                menuList:[],
                active:0
            }
        },
        created () {
            this.getMenuList()
        },
        methods: {
            getMenuList(){
                this.$http.get('/v1/menu/list',{params:{parentId:61}}).then((res)=>{
                    this.menuList = res.data
                });
            },
            handleOpen(key, keyPath) {
                this.active = key;
                //console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                //console.log(key, keyPath);
            }
        }
    }
</script>
<style scoped>
    body{
        background: #f5f7fa;
    }
    .page>>> .page-breadcrumb{
        margin: 0 0 30px 0;
    }
    .el-main{
        padding: 0;
    }
    .seller-logo{
        height: 59px;
        color: rgb(64, 158, 255);
        background: #303954;
        text-align: center;
        line-height: 60px;
        border-bottom: 1px solid #3e3e52;
        font-size: 18px;
        border-right: solid 1px #e6e6e6;
    }
    .el-aside{
        overflow: hidden;
    }
    .iconfont {
        margin:0 5px 0 0;
    }
    .el-menu{
      height: 100%;
    }
</style>
